import { validateName, validateContactNumber, validateSingleSelection, validateDateOfBirth, validateStreetAddress, validateDate, validatePassportNumber, validateStreetWithNumber, validatePostalAddress, validateLandline } from '@om/validation';

import { validateEmailAddress } from '@om/validation/src/validators/email-validator';
import {
    validateAlphaNumericString,
    validateFullName,
    validateGenericString,
    validateNameVTwo,
    validateNumericString,
} from '@om/validation/src/validators/string-validator';
import { validateBwIdNumber } from '@om/validation/src/validators/bw-id-number-validator';
import { setPurchasePersonalDetailsFieldValid } from '../../../actions/sizotsaFuneralCover/personalDetails';
import { validateSzIdNumber } from '@om/validation/src/validators/eswatini-id-number-validator';
import { validateDateBW } from '@om/validation/src/validators/date-validator';
import { getQuoteForm } from '../../../selectors/sizotsaFuneralCover/quote';
import { getPurchasePersonalDetailsForm } from '../../../selectors/sizotsaFuneralCover/personalDetails';

let prevValidationAction = null;

export const purchaseJourneyPersonalDetailsValidation = (store, next, action) => {
    const validationAction = (() => {
        const state=store.getState()
        const {nationality}=getPurchasePersonalDetailsForm(state)
        const trimValue = (value) => (value ? value.trim() : value);
        const removeWhiteSpacesFromValue = (value) => (value ? value.replace(/ /g, '') : value);
        let error;
        const getTommorowsDate = () => {
            const currentDate = new Date();
            currentDate.setDate(currentDate.getDate() + 1);
            const day = currentDate.getDate();
            const month = currentDate.getMonth() + 1;
            const year = currentDate.getFullYear();
            return `${day}/${month}/${year}`;
        };
    
        switch (action.value.fieldType) {
            case 'title':
                error = validateSingleSelection(action.value.value, 'Title');
                break;

            case 'firstName':
                error = validateNameVTwo(action.value.value, { subject: 'first name', min: 3, max: 66 });
                break;
            case 'middleName':
                error = action?.value?.value
                    ? validateName(action.value.value, { subject: 'middle name', min: 3, max: 66 })
                    : null;
                break;
            case 'surname':
                error = validateNameVTwo(action.value.value, { subject: 'Surname', min: 3, max: 66 });
                break;

            case 'nationality':
                error = validateSingleSelection(action.value.value, 'Nationality');
                break;

            case 'birthCountry':
                error = validateSingleSelection(action.value.value, 'Birth Country');
                break;

            case 'id':
                if(nationality.value==='Eswatini'){
                    error = validateSzIdNumber(action.value.value, {
                        required: true,
                        subject: 'Eswatini Id',
                        gender:action.value.gender,
                        dateOfBirth:action.value.dateOfBirth
                    });
                    break
                } 
                error = validateAlphaNumericString(action.value.value, {
                    min: 6,
                    max: 20,
                    required: true,
                    subject: 'Passport Id',
                });
                break;

            
            case 'expiryDate':
                error = validateDateBW(action.value.value, {
                    min: getTommorowsDate(),
                    subject:'id expiry date',
                    required: true,
                });
                break;
            case 'dateOfBirth':
                error = validateDateOfBirth(action.value.value, { min:18,required: true, subject: 'date of birth' });
                break;

            case 'prominentPerson':
                error = validateSingleSelection(action.value.value, 'an option');
                break;
                
            // case 'placeOfBirth':
            //     error = validateStreetAddress(trimValue(action.value.value), {
            //         min: 3,
            //         max: 75,
            //         subject: 'Place of birth',
            //     });
            //     break;

            case 'streetAddress':
                error = validateStreetAddress(action.value.value, {
                    min: 3,
                    max: 75,
                    required: true,
                    subject: 'street address',
                });
                break;

            case 'city':
                error = validateStreetAddress(trimValue(action.value.value), {
                    min: 1,
                    max: 75,
                    subject: 'city',
                });
                break;

            case 'country':
                error = validateSingleSelection(action.value.value, 'Country');
                break;

            case 'residenceTimePeriod':
                error = validateSingleSelection(action.value.value, 'Residence year');
                break;

            case 'previousPostalAddress':
                error = validateStreetAddress(action.value.value, {
                    min: 3,
                    max: 75,
                    required: true,
                    subject: 'Previous residential address',
                });
                break;

            case 'previousPostalCity':
                error = validateStreetAddress(trimValue(action.value.value), {
                    min: 1,
                    max: 75,
                    subject: 'Previos city',
                });
                break;

            case 'previousPostalCountry':
                error = validateSingleSelection(action.value.value, ' Previous residential Country');
                break;

            case 'postalSuburb':
                error = validatePostalAddress(action.value.value, {
                    min: 3,
                    max: 75,
                    required: true,
                    subject: 'Postal Suburb',
                });
                break;

            case 'postalCity':
                error = validateStreetAddress(trimValue(action.value.value), {
                    min: 1,
                    max: 75,
                    subject: 'Postal city',
                });
                break;

            case 'postalCountry':
                error = validateSingleSelection(action.value.value, ' Previous postal Country');
                break;

            case 'employementType':
                error = validateSingleSelection(action.value.value, 'employment type');
                break;

            case 'employeeOccupation':
                error = validateSingleSelection(action.value.value, 'Employee occupation');
                break;
    
            case 'otherEmployeeOccupation':
                error = validateAlphaNumericString(trimValue(action.value.value), {
                    min: 2,
                    max: 25,
                    subject: 'other occupation',
                    required: true
                });
                break;

            case 'sourceOfIncome':
                error = validateSingleSelection(action.value.value, 'Source of Income');
                break;
                
            case 'otherSourceOfIncome':
                error = validateAlphaNumericString(trimValue(action.value.value), {
                    min: 2,
                    max: 25,
                    subject: 'other source of income',
                    required: true
                });
                break;

            case 'workAddress':
                error = validateStreetAddress(trimValue(action.value.value), {
                    min: 3,
                    max: 75,
                    subject: 'Place of work',
                });
                break;

            case 'mobileNumber':
                error = validateContactNumber(removeWhiteSpacesFromValue(action.value.value), {
                    countryCode: 'sz',
                    leadingZeroValidation: false,
                    required:true,
                });
                break;
                
            case 'workTelephone':
                error = validateLandline(removeWhiteSpacesFromValue(action.value.value), {
                    countryCode: 'sz',
                    require:false,
                    leadingZeroValidation: false,
                });
                break;


            case 'email':
                error = validateEmailAddress(trimValue(action.value.value), {
                          min: 10,
                          max: 60,
                          subject: 'Email address',
                          required: false,
                      })
                break;

            case 'telephoneWork':
                error = validateLandline(removeWhiteSpacesFromValue(action.value.value), {
                    countryCode: 'sz',
                    subject:'telephone number',
                    required:false,
                    leadingZeroValidation: false,
                });
                break;

            default:
                return null;
        }
        return setPurchasePersonalDetailsFieldValid(error, action.value.fieldType);
    })();

    if (!validationAction) {
        return next(action);
    }

    store.dispatch(validationAction);
    prevValidationAction = validationAction;
    return next(action);
};
